import { moment } from "../date";
import type { Tables } from "../types";

export function getEmploymentYears(employment: Tables<"employments">) {
	const years: number[] = [];
	let validFromYear = moment(employment.validFrom).year();
	const validToYear = employment.validTo ? moment(employment.validTo).year() : moment().year();

	while (validFromYear <= validToYear) {
		years.push(validFromYear);
		validFromYear++;
	}

	return years;
}
